import { render } from "./StoryPieces.vue?vue&type=template&id=9b15212e"
import script from "./StoryPieces.vue?vue&type=script&lang=js"
export * from "./StoryPieces.vue?vue&type=script&lang=js"

import "./StoryPieces.vue?vue&type=style&index=0&id=9b15212e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__